import { render, staticRenderFns } from "./usaha.vue?vue&type=template&id=0fe834e6&"
import script from "./usaha.vue?vue&type=script&lang=js&"
export * from "./usaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports